<template>
  <div class="">
      <div class="uk-flex uk-flex-center uk-text-center">
          <h1>{{ completionTitle }}<span v-if="completionText === 'Pass'"><img width="15%" src="https://trainingvideocompliance.s3.amazonaws.com/KIR+Logo+w+AAA+on+Hat.JPG"></span></h1>
      </div>

      <hr class="divider">

      <div class="uk-text-center uk-padding-small uk-padding-remove-bottom">
          <h3>Score: {{ Math.floor(testscore * 100)+'%' }} </h3>
          <h3 style="margin-top: 0">Grade: {{ completionText }}</h3>
      </div>
  
      <div v-if="completionText === 'Pass'" class="uk-text-center uk-margin-bottom">
          
          <!-- <h2 style="margin: 1.5vh 0;"><strong>{{ passfailtext }}</strong></h2> -->
      </div>

      <hr class="divider">

      <div v-if="completionText === 'Pass' && this.fullTest.length !== 0">
          <div class="uk-text-center">
              <h2 style="margin:1.5vh 0;">Questions Review</h2>
              <div style="text-align:left" v-for="(item, i) in fullTest" :key="i">
                  <h3>Question {{i+1}}: {{item.question}}</h3>
                  <li class="uk-text-bold">{{ item.answer_one }}</li>
                  <li class="uk-text-bold" v-if="item.answer_two">{{ item.answer_two }}</li>
                  <li class="uk-text-bold" v-if="item.answer_three">{{ item.answer_three }}</li>
                  <li class="uk-text-bold" v-if="item.answer_four">{{ item.answer_four }}</li>
                  <li class="uk-text-bold" v-if="item.answer_five">{{ item.answer_five }}</li>
                  <h5 v-if="!item.incorrect">Correct Answer: {{ resolveCorrectText(item.correct_answer, i) }}</h5>
              </div>
          </div>
      </div>

      <div class="uk-text-center uk-margin-large ">
          <button @click="EndAction()" class="uk-button uk-button-primary navigate-frame-btn">{{ dashboardText }}</button>
      </div>
      
  </div>
</template>

<script>


export default {
  components: {
  
  },
    props: {
        frameNum:{
            type: Number,
            default: 0
        },
        nextFrame:{
            type: Function
        },
        title: {
            type: String,
            default: "Training Dashboard"
        },
        score: {
            type: Number,
            default: 0
        },
        completionText: {
            type: String,
            default: "Fail"
        },
        testscore: {
            type: Number,
            default: 0
        },
        fullTest: {
            type: Array,
            default: function(){
                return []
            }
        }
    },
    computed: {
        completionTitle: function(){
            if(this.completionText === "Pass"){
                return "Congratulations!"
            } else if(this.completionText === "Fail"){
                return "Completed"
            } else {
                return ""
            }
        },
        passfailtext: function(){
            if(this.completionText === "Pass"){
                return this.PassText
            } else if(this.completionText === "Fail"){
                return this.FailText
            } else {
                return ""
            }
        },
        dashboardText: function(){
            if(this.completionText === "Pass"){
                return "Finish"
            } else if(this.completionText === "Fail"){
                return "Try Again"
            } else {
                return ""
            }
        }
    },
    data: function(){
        return {
            hold: [],
            PassText:"Please complete this form to be eligible for Keep-It-Real Incentives!",
            FailText:"Unfortunately you have not passed the test yet. Feel free to try again!",
        }
    },
    methods: {
        resolveCorrectText(correct_answer, index){
            let text_source = ['zero','one','two','three','four','five','six']
            let text = text_source[Number(correct_answer)]
            let answer_key = "answer_"+text
            return this.fullTest[index][String(answer_key)]
        },
        NotificationsSignUp(...types){
            for(let t of types){
                this.hold.push(t)
            }
        },
        EndAction(){
            if(this.completionText === "Pass"){
                this.nextFrame(this.frameNum+1)
            } else if(this.completionText === "Fail"){
                this.nextFrame('dashboard-reset')
            } else {
                this.nextFrame('dashboard')
            }
        }
    }
}
</script>


<style scoped>

    h1 {
        text-align: center;
    }
    .transition-all {
        transition: all 333ms ease-in-out;
    }

    .cursor-pointer {
        cursor: pointer;
    }
    .divider {
        border: 2px solid #d9d9d9;
        margin: 0px 100px;
    }
    .card:hover {
        transform: translateY(-5px);
        box-shadow: 0px 5px 15px #a9a9a9;
    }
</style>
